// Modules
import { Link } from 'react-router';
import PropTypes from 'prop-types';
import React from 'react';
import _ from 'lodash';
import classNames from 'classnames';
import numeral from 'numeral';

import { FixedTable } from 'components/content-containers/tables';
import { GoogleDriveLink, XeroInvoiceLink } from 'components/widgets/icons/link-icons';
import { shortDate, superShortDate } from 'utils/format-utils';
import CheckableTR from 'components/content-containers/tables/checkable-tr';
import CompanyLink from 'components/models/company/company-link';
import SVG from 'components/widgets/icons/svg';
import SortableTH from 'components/content-containers/tables/sortable-th';
import Tooltip from 'components/widgets/overlays/tooltip';


// Component
function InvoicesTable({ invoices, update }) {
  return (
    <FixedTable className="checkbox-table">
      <thead>
        <tr>
          <th className="col-checkbox"></th>
          <th className="col-icon"></th>
          <th className="col-icon"></th>
          <th className="col-icon"></th>
          <th className="col-icon"></th>
          <SortableTH sortField="invoiceNumber" className="col-120">Invoice</SortableTH>
          <th className="col-icon"></th>
          <th className="col-icon"></th>
          <SortableTH sortField="company.name">Company</SortableTH>
          <SortableTH sortField="dueDate" className="col-120">Due Date</SortableTH>
          <SortableTH sortField="balance" className="col-money right-align">Balance</SortableTH>
          <SortableTH sortField="total" className="col-money right-align">Total</SortableTH>
        </tr>
      </thead>
      <tbody>
        {_.map(invoices, (invoice) =>
          <Tooltip
            elementType={CheckableTR}
            item={invoice}
            list={invoices}
            update={update}
            title={invoice.checkboxDisabled || ''}
            key={invoice.id}
            className={classNames({ 'disabled-row': invoice.checkboxDisabled })}
          >
            <td className="icon-cell">
              {invoice.emailedDate &&
                <Tooltip title={`Invoice emailed ${shortDate(invoice.emailedDate)}`}><SVG src="svg/email.svg" className="invoice-sent" /></Tooltip>
              }
              {!invoice.emailedDate &&
                <Tooltip title="Client requests emailed invoice"><SVG src="svg/email.svg" className="deemphasized-icon" /></Tooltip>
              }
            </td>
            <td className="icon-cell">
              {invoice.mailedDate &&
                <Tooltip title={`Invoice mailed ${shortDate(invoice.mailedDate)}`}><SVG src="svg/mail.svg" className="mail" /></Tooltip>
              }
              {invoice.deliveryMethod === 'Mail' && !invoice.mailedDate &&
                <Tooltip title="Client requests mailed invoice"><SVG src="svg/mail.svg" className="deemphasized-icon" /></Tooltip>
              }
            </td>
            <td className="icon-cell">
              {invoice.achProcessedDate &&
                <Tooltip title={`ACH Processed ${shortDate(invoice.achProcessedDate)}`}><SVG src="svg/payment-ach.svg" className="payment-ach" /></Tooltip>
              }
              {invoice.paymentMethod === 'ACH' && !invoice.achProcessedDate &&
                <Tooltip title="Client pays via ACH"><SVG src="svg/payment-ach.svg" className="deemphasized-icon" /></Tooltip>
              }
            </td>
            <td className="icon-cell">
              {invoice.purchaseOrderNumber &&
                <Tooltip title={`Purchase Order #: ${invoice.purchaseOrderNumber}`}><SVG src="svg/hashtag.svg" className="hashtag" /></Tooltip>
              }
              {invoice.company.purchaseOrderNumberRequired && !invoice.purchaseOrderNumber &&
                <Tooltip title="Client requires a purchase order number"><SVG src="svg/hashtag.svg" className="deemphasized-icon" /></Tooltip>
              }
            </td>
            <td>
              <Link to={`/accounting/invoices/${invoice.id}`}>
                {invoice.invoiceNumber || <small>Pending</small>}
              </Link>
            </td>
            <td>
              {invoice && invoice.xeroId &&
                <XeroInvoiceLink xeroId={invoice.xeroId} onClick={(e) => e.stopPropagation()} />
              }
            </td>
            <td>
              {invoice.invoiceNumber &&
                <GoogleDriveLink fileId={invoice.pdf.fileId} onClick={(e) => e.stopPropagation()} />
              }
            </td>
            <td>
              <CompanyLink company={invoice.company} />
            </td>
            <td>{superShortDate(invoice.dueDate)}</td>
            <td className="right-align">
              {_.isNil(invoice.balance) ?
                'Pending' :
                numeral(invoice.balance).format('$0,0.00')
              }
            </td>
            <td className="right-align">
              {_.isNil(invoice.total) ?
                'Pending' :
                numeral(invoice.total).format('$0,0.00')
              }
            </td>
          </Tooltip>
        )}
      </tbody>
    </FixedTable>
  );
}

// Prop types
InvoicesTable.propTypes = {
  invoices: PropTypes.array.isRequired,
  update: PropTypes.func.isRequired
};

export default InvoicesTable;
